import { render, staticRenderFns } from "./PriceFlowInfo.vue?vue&type=template&id=7151017f&"
import script from "./PriceFlowInfo.vue?vue&type=script&lang=js&"
export * from "./PriceFlowInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports